var _image;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAlertaMedia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    enableBackground: "new 0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "image0",
    width: 32,
    height: 32,
    x: 0,
    y: 0,
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAABGdBTUEAALGPC/xhBQAAACBjSFJN AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAOVBMVEUAAAD7dwD7dwD7eAD6 dwD7eAD6dwD/gAD6dwD6dwD7dwD/gAD/eQD6dgD6dwD7eAD6eAD6dwD///9+3WvgAAAAEXRSTlMA w83x8cS9DPr5yRQV/PvCwn0HcUYAAAABYktHRBJ7vGwAAAAAB3RJTUUH5gkPFBo42rpp8QAAAIBJ REFUOMvdk0sOgCAMRAcV8K+9/2UNCQnQUtCts2I6rw0QADJRFKqiQiI2xDQo7cVS5mMwkyRYk5hB GhC91QHLz4dagVoAMetC7hqAGEm1G2aVPwJSQC//Cnjf3NQc/MJyrMxnHebdk+s/2lTagtllnogD OGs5cPELuL9+XvX7P/ebLpCLipMCAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDIyLTA5LTE1VDIwOjI2 OjU2KzAwOjAwnlwSjwAAACV0RVh0ZGF0ZTptb2RpZnkAMjAyMi0wOS0xNVQyMDoyNjo1NiswMDow MO8BqjMAAAAASUVORK5CYII="
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertaMedia);
export default __webpack_public_path__ + "static/media/alertaMedia.0f0fb3e4.svg";
export { ForwardRef as ReactComponent };